module.exports = __webpack_public_path__ + "img/consultoria_16-9.05df2cae.jpg";